export default __webpack_public_path__ + "static/media/TimerRibbon.c063bffb.svg";